//copyright: Big Screen Entertainment Group Inc.
export default {
    hifm: '/hollywood_international_film_magazine',
    article00001: '/article00001_the_key_to_christmas',
    article00002: '/article00003_the_directors_who_changed_the_film_industry',
    article00003: '/article00002_collecting_history'
};